<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('sectionA.title') }}
    </h2>

    <!-- Height & Weight -->
    <div class="form-grid">
      <div class="mt-3">
        <label class="question-label">
          {{ t('sectionA.height') }}
        </label>
        <div class="form_group">
          <input
            type="number"
            v-model="form.height"
            :placeholder="t('sectionA.placeholder.height')"
            :class="{ 'is-invalid': formErrors.has('sectionA.height') }"
            @input="onHeightInput"
            @blur="onHeightBlur"
          />
          <p class="invalid-feedback" v-if="formErrors.has('sectionA.height')">
            {{ t(formErrors.first('sectionA.height')) }}
          </p>

        </div>
      </div>
      <div class="mt-3">
        <label class="question-label">
          {{ t('sectionA.weight') }}
        </label>
        <div class="form_group">
          <input
            type="number"
            v-model="form.weight"
            :placeholder="t('sectionA.placeholder.weight')"
            :class="{ 'is-invalid': formErrors.has('sectionA.weight') }"
            @input="onWeightInput"
            @blur="onWeightBlur"

          />
          <p class="invalid-feedback" v-if="formErrors.has('sectionA.weight')">
            {{ t(formErrors.first('sectionA.weight')) }}
          </p>
        </div>
      </div>
      <div class="mt-3">
        <label class="question-label">
          {{ t('sectionA.do_you_use_narcotics') }}
        </label>
        <div 
          class="radio-group"
          :class="{ 'is-invalid': formErrors.has('sectionA.narcotics') }"
        >
          <label class="radio-card">
            <input
              type="radio"
              value="yes"
              v-model="form.narcotics"
              @change="clearError('sectionA.narcotics')"
            />
            <span>{{ t('common.yes') }}</span>
          </label>

          <label class="radio-card">
            <input
              type="radio"
              value="no"
              v-model="form.narcotics"
              @change="clearError('sectionA.narcotics')"
            />
            <span>{{ t('common.no') }}</span>
          </label>
        </div>
        <p class="invalid-feedback" v-if="formErrors.has('sectionA.narcotics')">
          {{ t(formErrors.first('sectionA.narcotics')) }}
        </p>
      </div>
      <div class="mt-3">
        <label class="question-label">
          {{ t('sectionA.do_you_drink_acoholoic_beverages') }}
        </label>
        <div 
          class="radio-group"
          :class="{ 'is-invalid': formErrors.has('sectionA.alcoholic') }"
        >
          <label class="radio-card">
            <input
              type="radio"
              value="yes"
              v-model="form.alcoholic"
              @input="clearError('sectionA.alcoholic')"
            />
            <span>{{ t('common.yes') }}</span>
          </label>

          <label class="radio-card">
            <input
              type="radio"
              value="no"
              v-model="form.alcoholic"
              @input="alcoholicChange"
            />
            <span>{{ t('common.no') }}</span>
          </label>
        </div>
        <p class="invalid-feedback" v-if="formErrors.has('sectionA.alcoholic')">
          {{ t(formErrors.first('sectionA.alcoholic')) }}
        </p>
      </div>
      <div class="mt-3" v-if="form.alcoholic === 'yes'">
        <label class="question-label">
            {{ t('sectionA.specify_alcohol_consumption') }}
          </label>
        <div class="form_group">
          <input 
            type="text"
            :placeholder="t('sectionA.placeholder.specify_alcohol_consumption')"
            v-model="form.alcohol_consumption" 
            :class="{ 'is-invalid': formErrors.has('sectionA.alcohol_consumption') }"
            @input="clearError('sectionA.alcohol_consumption')"
          />
          <p class="invalid-feedback" v-if="formErrors.has('sectionA.alcohol_consumption')">
            {{ t(formErrors.first('sectionA.alcohol_consumption')) }}
          </p>
        </div>
      </div>
      <div class="mt-3">
        <label class="question-label">
            {{ t('sectionA.during_the_last_10_years_have_you_been_referred_to_any_of_the_following_examinations') }}
          </label>
          <div
            class="radio-group"
            :class="{ 'is-invalid': formErrors.has('sectionA.any_examination_in_last_10_years') }"
          >
            <label class="radio-card">
              <input
                type="radio"
                value="yes"
                v-model="form.any_examination_in_last_10_years"
                @change="clearError('sectionA.any_examination_in_last_10_years')"
              />
              <span>{{ t('common.yes') }}</span>
            </label>

            <label class="radio-card">
              <input
                type="radio"
                value="no"
                v-model="form.any_examination_in_last_10_years"
                @change="clearError('sectionA.any_examination_in_last_10_years')"
              />
              <span>{{ t('common.no') }}</span>
            </label>
          </div>
          <p class="invalid-feedback" v-if="formErrors.has('sectionA.any_examination_in_last_10_years')">
            {{ t(formErrors.first('sectionA.any_examination_in_last_10_years')) }}
          </p>
      </div>
      <div class="mt-3">
        <label class="question-label">
            {{ t('sectionA.are_you_now_or_have_you_been_sometime_during_the_last_10_years_about_to_undergo_a_surgery_transplantation') }}
          </label>
          <div 
            class="radio-group"
            :class="{ 'is-invalid': formErrors.has('sectionA.undergo_surgery_in_last_10_years') }"
          >
            <label class="radio-card">
              <input
                type="radio"
                value="yes"
                v-model="form.undergo_surgery_in_last_10_years"
                @change="clearError('sectionA.undergo_surgery_in_last_10_years')"
              />
              <span>{{ t('common.yes') }}</span>
            </label>

            <label class="radio-card">
              <input
                type="radio"
                value="no"
                v-model="form.undergo_surgery_in_last_10_years"
                @change="clearError('sectionA.undergo_surgery_in_last_10_years')"
              />
              <span>{{ t('common.no') }}</span>
            </label>
          </div>
          <p class="invalid-feedback" v-if="formErrors.has('sectionA.undergo_surgery_in_last_10_years')">
            {{ t(formErrors.first('sectionA.undergo_surgery_in_last_10_years')) }}
          </p>
      </div>
      <div class="mt-3">
        <label class="question-label">
            {{ t('sectionA.during_the_last_10_years_have_you_been_hospitalized') }}
          </label>
          <div
            class="radio-group"
            :class="{ 'is-invalid': formErrors.has('sectionA.hospitalized_in_last_10_years') }"
          >
            <label class="radio-card">
              <input
                type="radio"
                value="yes"
                v-model="form.hospitalized_in_last_10_years"
                @change="clearError('sectionA.hospitalized_in_last_10_years')"
              />
              <span>{{ t('common.yes') }}</span>
            </label>

            <label class="radio-card">
              <input
                type="radio"
                value="no"
                v-model="form.hospitalized_in_last_10_years"
                @change="clearError('sectionA.hospitalized_in_last_10_years')"
              />
              <span>{{ t('common.no') }}</span>
            </label>
          </div>
          <p class="invalid-feedback" v-if="formErrors.has('sectionA.hospitalized_in_last_10_years')">
            {{ t(formErrors.first('sectionA.hospitalized_in_last_10_years')) }}
          </p>
      </div>
      <div class="mt-3">
        <label class="question-label">
          {{ t('sectionA.during_the_last_10_years_have_you_been_taking_or_have_you_received_a_recommendation_to_take_medications_regularly') }}
        </label>
        <div
          class="radio-group"
          :class="{ 'is-invalid': formErrors.has('sectionA.recommendation_to_take_medications_regularly_in_last_10_years') }"
        >
          <label class="radio-card">
            <input
              type="radio"
              value="yes"
              v-model="form.recommendation_to_take_medications_regularly_in_last_10_years"
              @change="clearError('sectionA.recommendation_to_take_medications_regularly_in_last_10_years')"
            />
            <span>{{ t('common.yes') }}</span>
          </label>

          <label class="radio-card">
            <input
              type="radio"
              value="no"
              v-model="form.recommendation_to_take_medications_regularly_in_last_10_years"
              @change="clearError('sectionA.recommendation_to_take_medications_regularly_in_last_10_years')"
            />
            <span>{{ t('common.no') }}</span>
          </label>
        </div>
        <p class="invalid-feedback" v-if="formErrors.has('sectionA.recommendation_to_take_medications_regularly_in_last_10_years')">
          {{ t(formErrors.first('sectionA.recommendation_to_take_medications_regularly_in_last_10_years')) }}
        </p>
      </div>
      <div class="mt-3">
        <label class="question-label">
          {{ t('sectionA.have_you_been_diagnosed_as_suffering_from_any_allergies') }}
        </label>
        <div 
          class="radio-group"
          :class="{ 'is-invalid': formErrors.has('sectionA.suffering_from_any_allergies') }"
        >
          <label class="radio-card">
            <input
              type="radio"
              value="yes"
              v-model="form.suffering_from_any_allergies"
              @change="clearError('sectionA.suffering_from_any_allergies')"
            />
            <span>{{ t('common.yes') }}</span>
          </label>

          <label class="radio-card">
            <input
              type="radio"
              value="no"
              v-model="form.suffering_from_any_allergies"
              @change="clearError('sectionA.suffering_from_any_allergies')"
            />
            <span>{{ t('common.no') }}</span>
          </label>
        </div>
        <p class="invalid-feedback" v-if="formErrors.has('sectionA.suffering_from_any_allergies')">
          {{ t(formErrors.first('sectionA.suffering_from_any_allergies')) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import Error from '@/utils/Error';
import { reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({ modelValue: Object, 
  formErrors:{
    type:Object,
    required:false,
    default:new Error(reactive({}))
  }
});
const emit = defineEmits(['update:modelValue','removeError','setError']);
const form = reactive({...props.modelValue})
watch(form, (newVal) => {
  emit('update:modelValue',newVal)
})

watch(() => props.modelValue,
(newVal) => {
  Object.assign(form,{...newVal});
}, { deep: true, immediate: true })
const clearError = async(name)=>{
	emit("removeError",name)
}
const setError = (key, value) => {
  emit('setError', {
    key: key,
    message: value
  });
}
const alcoholicChange = async() => {
  clearError(`sectionA.alcoholic`);
  if(form.value?.alcoholic === "yes"){
    form.value.alcohol_consumption = null
  }
}
const onHeightInput = async () => {
  await validateRange('height', 'sectionA.height', 100, 230);
}

const onWeightInput = async () => {
  await validateRange('weight', 'sectionA.weight', 30, 300);
}
const onHeightBlur = () =>{
  clampInteger('height', 100, 230);
  if (hasValue('height')) clearError('sectionA.height');
}
const onWeightBlur = () => {
  clampInteger('weight', 30, 300);
  if (hasValue('weight')) clearError('sectionA.weight');
}
// Leaving an empty field must keep its "required" error visible
const hasValue = (field) => form[field] !== null && form[field] !== undefined && form[field] !== '';
const clampInteger = (field, min, max) => {
  const raw = form[field];
  if (raw === null || raw === '') return;
  let num = Math.trunc(Number(raw));
  if (isNaN(num)) {
    form[field] = null;
    return;
  }
  if (num < min) num = min;
  if (num > max) num = max;
  if (num !== Number(raw)) {
    form[field] = num;
  }
}
const validateRange = (field, errorKey, min, max) => {
  const raw = form[field];
  const num = Math.trunc(Number(raw));
  
  if (isNaN(num) || !Number.isInteger(num)) {
    setError(errorKey, `validation.${errorKey}.integer`);
    return;
  }

  if (num < min) {
    setError(errorKey, `validation.${errorKey}.min`);
    return;
  }
  
  if (num > max) {
    setError(errorKey, `validation.${errorKey}.max`);
    return;
  }
  clearError(errorKey);
}
// defineExpose({
// 	removeError
// })
</script>
<style>
.radio-card:hover {
  border-color: #2563eb;
}

.radio-card input:checked + span {
  font-weight: 600;
}
</style>